/** Ambiente DEV (cloud) - *.dev.oneeduca.com.br */
export const environment = {
  production: false,
  name: 'dev' as const,
  useMockAuth: false,
  apiUrl: 'https://api.dev.oneeduca.com.br/api/v1',
  authSpaUrl: 'https://auth.dev.onefactory.com.br/auth/login',
  authBaseUrl: 'https://api.dev.auth.onefactory.com.br',
  authAdminUrl: 'https://admin.dev.onefactory.com.br',
  authCallbackUrl: 'https://admin.dev.oneeduca.com.br/auth/callback',
  oauth: {
    clientId: '019ebd1c-3eed-7101-a7b6-7de43a0cb6c6',
  },
};
